import React from "react";

export default function QuoteSection() {
  return (
    <section
      id="tukor"
      data-testid="quote-section"
      className="relative py-10 md:py-14 px-6 md:px-10"
    >
      <div className="max-w-5xl mx-auto text-center">
        {/* Centered eyebrow */}
        <p
          data-testid="quote-eyebrow"
          className="text-[12px] tracking-[0.35em] uppercase text-gold mb-5 font-body"
        >
          — Gyermeki lélek — Kapcsolódás és tükör
        </p>

        {/* Centered section title (visual anchor) */}
        <h2
          data-testid="quote-title"
          className="font-serif-display text-[34px] sm:text-[40px] md:text-[46px] leading-[1.15] text-graphite mb-10"
        >
          A legtisztább <em className="text-gold" style={{ fontStyle: "italic" }}>tükör</em>
        </h2>

        {/* Big champagne quotation mark */}
        <div
          aria-hidden="true"
          className="ornament-quote text-[120px] md:text-[150px] mb-[-40px] md:mb-[-50px] select-none"
        >
          “
        </div>

        {/* Quote — fully centered */}
        <blockquote
          data-testid="quote-text"
          className="font-serif-display text-[24px] sm:text-[28px] md:text-[32px] leading-[1.4] text-graphite italic font-normal"
        >
          A gyermeki lélek a legtisztább tükör, melybe mélyen belenézve meglátod önmagad
          s mindazt a lehetőséget, melyet számodra életutad tartogat. Gyermeked
          megjavítása helyett, tiszta kapcsolódásra törekedj, ez minden téren elhozza a
          megoldást Neked!
        </blockquote>

        {/* Author — centered */}
        <div className="mt-10 flex items-center justify-center gap-4">
          <span className="block w-10 h-px" style={{ backgroundColor: "var(--accent-gold)" }} />
          <cite
            data-testid="quote-author"
            className="not-italic font-body text-[12px] tracking-[0.3em] uppercase text-graphite-soft"
          >
            Szász-Tóth Enikő
          </cite>
          <span className="block w-10 h-px" style={{ backgroundColor: "var(--accent-gold)" }} />
        </div>

        {/* Flowing reflection — left-aligned book prose */}
        <div
          data-testid="reflection-text"
          className="reading-prose mt-14 md:mt-16 text-[16px] md:text-[17px] leading-[1.9] text-graphite font-body font-light"
        >
          <p>
            Belenézve gyakran többet látunk önmagunkból, mint szeretnénk, vagy mint amire
            számítottunk. Talán ezért olyan mélyek azok a felismerések, amelyeket a gyermekünk
            mellett élhetünk meg — pici kortól kezdve egészen felnőtt korig. Azonban ha még
            mélyebbre tekintünk, észrevesszük, hogy nem csak a gyermekünk tükröz bennünket: a
            kapcsolataink, a találkozásaink, az élethelyzeteink is.
          </p>
        </div>

        {/* Centered closing highlights — two separate elegant stops */}
        <div data-testid="quote-closing-highlights" className="mt-14 md:mt-16 text-center">
          <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-graphite max-w-xl mx-auto">
            Minden kapcsolat hordoz valamilyen{" "}
            <span className="text-gold">ajándékot</span>.
          </p>

          <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-graphite max-w-xl mx-auto mt-8 md:mt-10">
            A kérdés csupán az:
            <br />
            <span className="text-gold">készen állunk-e</span> meglátni benne?
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-10 md:mt-12 hairline" />
    </section>
  );
}
